import ApiBase from "../api-base";

class CoWorkingApi extends ApiBase {
    async getCoWorkingBookings(params) {
        const response = await this.get(`/co-working-bookings`, { ...params });

        return response.data;
    }

    async getCoWorkingBooking(id) {
        const response = await this.get(`/co-working-bookings/${id}`);

        return response.data;
    }

    async getCoWorkingSpace(id) {
        const response = await this.get(`/co-working-spaces/${id}`);

        return response.data;
    }

    async getDayAvailability(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-spaces/${id}/day-availability`, params, validationHandler);
            return response.data;
        });
    }

    async getMonthAvailability(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-spaces/${id}/month-availability`, params, validationHandler);
            return response.data;
        });
    }

    async getBookingCosts(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-spaces/${id}/quote`, params, validationHandler);
            return response.data;
        });
    }

    async getIndexBookingMonthAvailability(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-spaces/month-availability`, params, validationHandler);
            return response.data;
        });
    }

    async getCoWorkingSpaces(params) {
        const response = await this.get(`/co-working-spaces`, { params });

        return response.data;
    }

    async createCoWorkingBooking(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-bookings/book`, params, validationHandler);
            return response.data;
        });
    }

    async cancelCoWorkingBooking(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-bookings/${id}/cancel`, params, validationHandler);
            return response.data;
        });
    }

    async cancelCoWorkingBookingQuote(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-bookings/${id}/quote-cancel`, params, validationHandler);
            return response.data;
        });
    }

    async updateCoWorkingBooking(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/co-working-bookings/${id}`, params, validationHandler);
            return response.data;
        });
    }
}

export default new CoWorkingApi();